import gsap from 'gsap';
import gsapCore from 'gsap/gsap-core';
import ScrollTrigger from "gsap/ScrollTrigger";
export default {
  init() {
    if($('.block-subscribe').length){
      gsap.registerPlugin(ScrollTrigger); 

      var blockName = '.block-subscribe';
      gsap.set(blockName, {autoAlpha:0, y:100});

      gsap.to(blockName, {
        scrollTrigger : {
          trigger : blockName,
          start : 'top bottom'
        },
        autoAlpha:1, y:0
      });
        
    }
  },
  finalize() {}
}